var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8839 30.6846C24.3573 30.6846 31.2263 23.8157 31.2263 15.3423C31.2263 6.86899 24.3573 0 15.8839 0C7.41062 0 0.541626 6.86899 0.541626 15.3423C0.541626 23.8157 7.41062 30.6846 15.8839 30.6846Z",
    fill: "#00E676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2274 15.4132L15.8839 26.6422L4.53809 15.4132L15.8861 4.17969L22.973 11.2015L15.8839 18.2187L13.0469 15.4132L17.3013 11.2015L15.8839 9.79755L10.2121 15.4132L15.8839 21.0266L24.3927 12.6054L27.2274 15.4132Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrg);
export default __webpack_public_path__ + "static/media/NRG.cd5690bb08ce35111bcfa452e484c7af.svg";
export { ForwardRef as ReactComponent };